import type { TestListItem } from "../api/schemas";
import { TestsListRow } from "./TestsListRow";

export type LoadState =
  | { kind: "loading" }
  | { kind: "error"; message: string }
  | { kind: "ready" };

export type TestsListProps = {
  tests: TestListItem[];
  selectedId: number | null;
  loadState: LoadState;
  onNewTest: () => void;
  onSelect: (id: number) => void;
};

export function TestsList({
  tests, selectedId, loadState, onNewTest, onSelect,
}: TestsListProps) {
  return (
    <aside className="tests-list">
      <div className="tests-list-header" data-testid="tests-list-header">
        <span className="tests-list-title">
          Studies <span className="tests-list-count">{tests.length}</span>
        </span>
        <button
          type="button"
          data-testid="tests-list-new-button"
          onClick={onNewTest}
          className="tests-list-new"
        >
          + New
        </button>
      </div>
      <div className="tests-list-body">
        {loadState.kind === "loading" && (
          <div className="muted" data-testid="tests-list-loading">Loading…</div>
        )}
        {loadState.kind === "error" && (
          <div
            data-testid="tests-list-error"
            style={{ color: "#ff9a9a", fontSize: "12px" }}
          >
            {loadState.message}
          </div>
        )}
        {loadState.kind === "ready" && tests.length === 0 && (
          <div className="muted" data-testid="tests-list-empty">
            No studies yet. Click <strong>+ New</strong> to start one.
          </div>
        )}
        {loadState.kind === "ready" && tests.length > 0 && tests.map((t) => (
          <TestsListRow
            key={t.id}
            test={t}
            active={t.id === selectedId}
            onClick={() => onSelect(t.id)}
          />
        ))}
      </div>
    </aside>
  );
}
